import React, { useEffect, useState } from "react";
import { Button, Spin } from "antd";
import { InfoCircleTwoTone } from "@ant-design/icons";

const ScormPreviewTest2 = ({ link }) => {
  console.log(link);
  const [launchUrl, setLaunchUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const studentId = "123456";
  const studentName = "John Doe";

  useEffect(() => {
    const mockAPI = {
      LMSInitialize: () => "true",
      LMSFinish: () => "true",
      LMSGetValue: (key) => {
        console.log("LMSGetValue", key);
        if (key === "cmi.core.student_id") return studentId;
        if (key === "cmi.core.student_name") return studentName;
        return "";
      },
      LMSSetValue: (key, value) => {
        console.log("LMSSetValue", key, value);
        return "true";
      },
      LMSCommit: () => "true",
      LMSGetLastError: () => "0",
      LMSGetErrorString: () => "No error",
      LMSGetDiagnostic: () => "",
    };

    const mockAPI_1484_11 = {
      Initialize: () => "true",
      Terminate: () => "true",
      GetValue: (key) => {
        console.log("GetValue", key);
        if (key === "cmi.learner_id") return studentId;
        if (key === "cmi.learner_name") return studentName;
        return "";
      },
      SetValue: (key, value) => {
        console.log("SetValue", key, value);
        return "true";
      },
      Commit: () => "true",
      GetLastError: () => "0",
      GetErrorString: () => "No error",
      GetDiagnostic: () => "",
    };

    window.API = mockAPI;
    window.API_1484_11 = mockAPI_1484_11;
  }, []);

  useEffect(() => {
    const loadScorm = async () => {
      if (!link) {
        setError("No SCORM link provided.");
        setLoading(false);
        return;
      }

      const manifestUrl = `${link}imsmanifest.xml`;

      setLoading(true);
      setError("");
      setLaunchUrl(null);

      try {
        const res = await fetch(manifestUrl);
        if (!res.ok) throw new Error("Manifest not found");

        const text = await res.text();
        const parser = new DOMParser();
        const xml = parser.parseFromString(text, "application/xml");

        const resource = xml.querySelector("resource");
        const href = resource?.getAttribute("href");

        if (href) {
          const url = new URL(`${link}${href}`, window.location.origin);
          url.searchParams.append("student_id", studentId);
          url.searchParams.append("learner_id", studentId);
          setLaunchUrl(url.toString());

          console.log("Launch file (href):", href);
          console.log("Full launch URL:", url.toString());
        } else {
          throw new Error("No launch file found in manifest.");
        }
      } catch (err) {
        console.error("SCORM manifest error:", err);
        setError("Failed to load SCORM content.");
      } finally {
        setLoading(false);
      }
    };

    loadScorm();
  }, [link]);
  const handleOpenNewTab = () => {
    if (launchUrl) {
      window.open(launchUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div style={{ padding: "1rem" }}>
      {loading ? (
        <Spin tip="Loading SCORM content..." />
      ) : error ? (
        <p style={{ color: "red" }}>{error}</p>
      ) : launchUrl ? (
        <>
          <iframe
            src={launchUrl}
            width="100%"
            height="600px"
            title="SCORM Player"
            style={{ border: "1px solid #ccc", borderRadius: "8px" }}
            allowFullScreen
            // scrolling="no"
            sandbox="allow-scripts allow-same-origin allow-modals allow-forms allow-popups allow-presentation allow-pointer-lock"
          />
          <div style={{ textAlign: "center", marginTop: "1rem" }}>
            <Button
              // type="primary"
              icon={<InfoCircleTwoTone />}
              onClick={handleOpenNewTab}
            >
              If SCORM is not loading correctly, view in new tab
            </Button>
          </div>
        </>
      ) : (
        <p>No content to display.</p>
      )}
    </div>
  );
};

export default ScormPreviewTest2;
